/*
 * Vistos recientemente (Recently viewed) — patrón idiomático Shopify.
 *
 * - Graba cada producto visto en localStorage (id + handle).
 * - Trae las tarjetas NATIVAS del theme vía Section Rendering API:
 *     /search?q=id:.. OR id:..&type=product&section_id=recently-viewed
 *   La sección recently-viewed.liquid, en contexto de búsqueda, renderiza
 *   resource-card por cada resultado.
 * - Reordena por recencia (la búsqueda ordena por relevancia) y las inyecta.
 * - Oculta la banda si no hay productos que mostrar.
 */
(function () {
  var KEY = 'sk_rv_v2';
  var MAX_STORE = 12;

  function read() {
    try {
      var l = JSON.parse(localStorage.getItem(KEY) || '[]');
      // Solo entradas válidas (id numérico + handle) para el query id:..
      return Array.isArray(l) ? l.filter(function (p) { return p && p.id && p.handle; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORE))); } catch (e) {}
  }

  function handleFromHref(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.record();
      this.render();
    }

    record() {
      var id = this.dataset.currentId;
      var handle = this.dataset.currentHandle;
      if (!id || !handle) return;
      var list = read().filter(function (p) { return p.handle !== handle; });
      list.unshift({ id: id, handle: handle });
      write(list);
    }

    get grid() {
      return this.querySelector('[data-recently-viewed-grid]');
    }

    render() {
      var self = this;
      var current = this.dataset.currentHandle;
      var max = parseInt(this.dataset.max || '4', 10);

      var list = read().filter(function (p) { return p.handle !== current; });
      if (!list.length) { this.hidden = true; return; }

      // Pedimos algunos de más por si alguno ya no existe / no está disponible.
      var wanted = list.slice(0, max + 4);
      var query = wanted.map(function (p) { return 'id:' + p.id; }).join(' OR ');

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'search?q=' + encodeURIComponent(query) +
        '&type=product&options[unavailable_products]=last&section_id=' + this.dataset.sectionId;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fetchedGrid = doc.querySelector('[data-recently-viewed-grid]');
          if (!fetchedGrid) { self.hidden = true; return; }

          // Inyectar la hoja de estilos agregada de la sección (una sola vez).
          var st = doc.querySelector('style[data-section-stylesheet]');
          if (st && !document.getElementById('rv-section-styles')) {
            st.id = 'rv-section-styles';
            document.head.appendChild(st);
          }

          var items = Array.prototype.slice.call(fetchedGrid.querySelectorAll('.recently-viewed__item'));
          if (!items.length) { self.hidden = true; return; }

          // Reordenar por recencia usando el handle del enlace.
          var order = {};
          wanted.forEach(function (p, i) { order[p.handle] = i; });
          items.sort(function (a, b) {
            var ha = handleFromHref(a), hb = handleFromHref(b);
            var oa = (ha != null && order[ha] != null) ? order[ha] : 9999;
            var ob = (hb != null && order[hb] != null) ? order[hb] : 9999;
            return oa - ob;
          });

          var grid = self.grid;
          if (!grid) { self.hidden = true; return; }
          grid.innerHTML = '';
          items.slice(0, max).forEach(function (it) { grid.appendChild(it); });
          self.hidden = false;
          self.setupCarousel();
        })
        .catch(function () { self.hidden = true; });
    }

    // Carrusel mobile: flechas que hacen scroll por vista + centrado vertical sobre la imagen.
    setupCarousel() {
      var self = this;
      var grid = this.grid;
      var prev = this.querySelector('.recently-viewed__arrow--prev');
      var next = this.querySelector('.recently-viewed__arrow--next');
      if (!grid || !prev || !next) return;

      function centerArrows() {
        // La imagen (.resource-card__media) para centrar la flecha sobre ella, no sobre toda la tarjeta.
        var media = grid.querySelector('.resource-card__media') || grid.querySelector('.recently-viewed__item');
        if (media && media.offsetHeight) {
          self.style.setProperty('--rv-arrow-top', (media.offsetHeight / 2) + 'px');
        }
      }
      function update() {
        var maxScroll = grid.scrollWidth - grid.clientWidth - 1;
        var carousel = grid.scrollWidth > grid.clientWidth + 1;
        prev.hidden = !carousel || grid.scrollLeft <= 0;
        next.hidden = !carousel || grid.scrollLeft >= maxScroll;
      }

      prev.addEventListener('click', function () {
        grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' });
      });
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', function () { centerArrows(); update(); });

      centerArrows();
      update();
      // Reintento tras cargar imágenes (offsetHeight fiable) y por si el layout tarda.
      setTimeout(function () { centerArrows(); update(); }, 300);
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
